// Sets an attribute and value into an element
// NOTE: this function WILL replace the value, 
// for classes use setClassIfVisible instead to account for multiple classes
// attrName defines the attribute being changed, from styles it just supports "backgroundImage"
// REQUIRES: 
// * util-set-attribute.js
const setAttributeIfVisible = function (elem, attrName, attrVal) {
  if (!elem || !attrName || !attrVal) return;

  const name = attrName.trim();
  const supportsObserver = ("IntersectionObserver" in window && "IntersectionObserverEntry" in window && "intersectionRatio" in window.IntersectionObserverEntry.prototype);
  const val = attrVal.trim();
  // If it doesn't support an observer
  // we fallback into just showing it
  if (!supportsObserver) {
    setAttribute(elem, attrName, val);
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    if (entries[0].isIntersecting) {
      setAttribute(entries[0].target, name, val);
      observer.unobserve(entries[0].target);
    }
  });
  observer.observe(elem);
}